import { IInventoryItem } from './IInventoryItem';

export interface IInventoryTemplateDetail {
  inventoryTemplateDetailId: string;
  inventoryTemplateId: string;
  item: IInventoryItem;
  recommendedInventoryLevel: number;
  isActive: boolean;
  sortOrder: number;
  itemGroupSortOrder: number;
}
